/** @jsxImportSource react */
import { Button } from '@react/system';
import { ReactNode } from 'react';

export default function NoData({
  children,
  noData,
}: {
  children?: ReactNode;
  noData: boolean;
}) {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <div className='relative w-full'>
      {noData && (
        <div className='absolute inset-0 flex flex-col items-start bg-slate-base bg-opacity-20 text-white backdrop-blur-[2px] backdrop-filter'>
          <div className='relative flex h-full w-full  flex-col items-center justify-center space-y-6 p-8 text-white shadow-xl'>
            <Button
              onClick={() => handleScrollToTop()}
              className='bg-white'
              variant='neutral'
            >
              Enter location to compare cost
            </Button>
          </div>
        </div>
      )}

      {children}
    </div>
  );
}
